import { text } from '#contract'
import type { LocalizedText } from '#contract'

/** "now", "< 15 min", "45 min", "2 h", "1 h 30 min" for an ETA in whole quarter hours. */
export function etaText(minutes: number): LocalizedText {
  if (minutes <= 0) return text('tasks.eta.due')
  if (minutes <= 15) return text('tasks.eta.soon')
  return durationText(minutes)
}

/** "45 min", "2 h", "1 h 30 min" for whole minutes. */
export function durationText(minutes: number): LocalizedText {
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return text('tasks.eta.minutes', { m })
  return m === 0 ? text('tasks.eta.hours', { h }) : text('tasks.eta.hoursMinutes', { h, m })
}
